// A world wider than the screen that scrolls sideways as you walk (the wide Podwórko; the street does the
// same by hand in OutsideScene). Pure, so node tests cover it; ui/sideScrollCamera.js drives the camera.

// The camera's scrollX that centres `targetX`, clamped so the view never leaves the world.
export function scrollTargetX(targetX, worldW, viewW) {
  return Math.max(0, Math.min(worldW - viewW, targetX - viewW / 2));
}

// Frame-rate-independent easing toward `goal`: ~63% of the gap closes every `tauS` seconds.
export function easeScroll(cur, goal, dtMs, tauS = 0.15) {
  const k = 1 - Math.exp(-(dtMs / 1000) / tauS);
  return cur + (goal - cur) * k;
}
